export const createNotificationUI = (set, get) => ({
  notificationUI: {
    unseen_notifications: 0,
    toggle: false,
    external_rac_files_unseen: 0,
    is_notification_cross_icon_clicked: false,
    side_bar_collapsed: false
  },

  setNotificationSeenUnseen: (payload) =>
    set((state) => ({
      notificationUI: {
        ...state.notificationUI,
        ...payload,
      },
    })),

  toggleController: () =>
    set((state) => ({
      notificationUI: {
        ...state.notificationUI,
        toggle: !state.notificationUI.toggle,
        unseen_notifications: 0,
        is_notification_cross_icon_clicked: false,
        side_bar_collapsed: false
      },
    }))
});



// WEBPACK FOOTER //
// ./src/store/slices/NotificationSlice/notification_seen_unseen.js